import React, {PropTypes} from 'react';
import Pager from '../partial/Pager/Pager';
import NoResultHeader from '../partial/NoResultHeader/NoResultHeader';
import PageTitle from '../partial/PageTitle/PageTitle';
import Breadcrumbs from '../partial/Breadcrumbs/Breadcrumbs';
import BugFixSingleAccordionArticle from '../partial/BugFixSingleAccordionArticle/BugFixSingleAccordionArticle';
import BugFixSingleArticle from '../partial/BugFixSingleArticle/BugFixSingleArticle';
import utils from '../../utils/utils';
const s = require('./bugs.scss');

function getSingleArticleView(accordion, article) {

  if (accordion) {
    return [<BugFixSingleAccordionArticle
      key={article.id}
      index={article.id}
      date={`${article.date.month} ${article.date.day}, ${article.date.year}`}
      title={article.title}
      content={utils.getContent(article.content)}
      links={article.links}
      />];
  }

  return [<BugFixSingleArticle
    key={article.id}
    date={`${article.date.month} ${article.date.day}, ${article.date.year}`}
    title={article.title}
    content={utils.getContent(article.content)}
    links={article.links}
    />];
}


const BugFixes = ({loading, numPages, page, tag, title, content, pageHeader, search, activeExperiments, locale}) => {
  if (content.length === 0) {
    return (
      <div className={s.postsWrapper} >
        {utils.getHelemt(pageHeader)}
        <div className={s.container}>
          <NoResultHeader search={() => search('')} locale={locale}/>
        </div>
      </div>
    );
  } else {
    return (
      <div className={s.postsWrapper} data-hide={loading}>
        {utils.getHelemt(pageHeader)}
        <div className={s.container}>
          <PageTitle title={pageHeader.title} description={pageHeader.description}/>
          <Breadcrumbs title={title} showing={locale[`wix-general_page_showing`]}/>
          <ul className={s.myGalleryClass} data-hook="article-wrapper">
            {
              content.map(article => getSingleArticleView(activeExperiments.indexOf('bugsFixAccordionDesign') !== -1, article))
            }
          </ul>
        </div>
        <Pager data-hook="bug-fixes-pager" numPages={numPages} visiblePages="3" current={page} relPath={tag}/>
      </div>
    );
  }
};

BugFixes.propTypes = {
  loading: PropTypes.bool.isRequired,
  numPages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  tag: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.array.isRequired,
  pageHeader: PropTypes.object.isRequired,
  search: PropTypes.func.isRequired,
  activeExperiments: PropTypes.array,
  locale: PropTypes.object.isRequired
};

export default BugFixes;



// WEBPACK FOOTER //
// ./components/BugFixes/BugFixes.js